export default "__VITE_ASSET__jXrUiH6L__"